import React from 'react';
import { Typography } from '@mui/material';

import { CloseButton, Dialog, DialogContent, DialogTitle } from 'components';
import { ZoneScheduleTimeForm } from 'forms';

interface ZoneScheduleUpdateDialogProps {
  open: boolean;
  onClose: Function;
  minutes: number;
  onSubmit: (value: number) => void;
}

export const ZoneScheduleUpdateDialog = ({ open, onClose, onSubmit, minutes }: ZoneScheduleUpdateDialogProps) => {
  return (
    <Dialog
      onClose={() => onClose()}
      open={open}
      onMouseDown={(event) => {
        // stop the mouse click propagation that was causing the slider to drag
        event.stopPropagation();
      }}
    >
      <DialogTitle>
        <Typography variant="h5" component="span">
          Manually Add Cleaning Time
        </Typography>
      </DialogTitle>

      <DialogContent>
        <ZoneScheduleTimeForm minutes={minutes} onSubmit={onSubmit} />
      </DialogContent>

      <CloseButton onClick={() => onClose()} />
    </Dialog>
  );
};
